<template>
  <div
    :class="{'tw-relative xl:tw-absolute xl:tw-w-[263px] tw-w-full tw-mt-3 xl:tw-mt-0': !isOnboardingRedesign}"
    :style="[
      $_breakpoint_xl && {
        bottom: `${bottom}px`,
        left: `${left}px`
      }
    ]"
  >
    <template v-if="isOnboardingRedesign">
      <p class="tw-text-xl tw-mb-2">
        Please ensure:
      </p>
    </template>
    <template v-else>
      <p class="label-header">
        Ensure that:
      </p>
    </template>

    <p
      v-for="item in items"
      :key="item"
      class="mb-0"
    >
      - {{ item }}
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// utils
import { observeResize } from '@corefront/utils/observeResize';

// mixins
import { breakpoint } from '@corefront/mixins-v2/breakpoint';

function contentRectToObject(rect) {
  const { width, height, top, right, bottom, left, x, y } = rect;
  return { width, height, top, right, bottom, left, x, y };
}

export default {
  mixins: [breakpoint],
  props: {
    page: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      onboardingContentRect: null,
      promoBannerRect: null,
      idItems: [
        'Your ID is fully visible.',
        'The photo isn’t blurry or dark.',
        'Your ID is government-issued and not expired.',
        'Your file is the appropriate size (max 25 MB) and an accepted file type (png, jpg, jpeg, pdf, heic, tiff, pjpeg).'
      ],
      photoItems: [
        "Your photo isn't blurry or dark.",
        'Your file is the appropriate size (max 25 MB) and an accepted file type (png, jpg, jpeg, pdf, heic, tiff, pjpeg).'
      ]
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    items() {
      if (this.isOnboardingRedesign) {
        return this.page === 'id' ? this.idItems : this.photoItems;
      }

      return [
        'Your ID is not cutoff',
        'The photo is not blurry or dark',
        'Your ID is government issued and not expired',
      ]
    },
    bottom () {
      if (!this.onboardingContentRect || !this.promoBannerRect) {
        return 0
      }

      return window.innerHeight -
        this.onboardingContentRect.bottom || 0 -
        this.promoBannerRect.height || 0
    },
    left () {
      if (!this.onboardingContentRect) {
        return 0
      }

      return this.onboardingContentRect.left
    }
  },
  mounted () {
    observeResize(['.onboarding-content'], els => {
      const [onboardingContent] = els
      this.onboardingContentRect = contentRectToObject(onboardingContent.contentRect)
    })

    observeResize(['#fsa-has-store-banner'], els => {
      const [promoBanner] = els
      this.promoBannerRect = contentRectToObject(promoBanner.contentRect)
    })
  },
}
</script>